import * as THREE from "three";

let screenX = 0;
let screenY = 0;
let canvasRect: DOMRect | null = null;

export function setDragScreenPosition(x: number, y: number) {
  screenX = x;
  screenY = y;
}

export function setDragCanvasRect(rect: DOMRect | null) {
  canvasRect = rect;
}

export function getDragScreenPosition(): { x: number; y: number } {
  return { x: screenX, y: screenY };
}

export function getDragCanvasRect(): DOMRect | null {
  return canvasRect;
}

export function isOverCanvas(): boolean {
  if (!canvasRect) return false;
  return (
    screenX >= canvasRect.left &&
    screenX <= canvasRect.right &&
    screenY >= canvasRect.top &&
    screenY <= canvasRect.bottom
  );
}

export function screenToNDC(): THREE.Vector2 | null {
  if (!canvasRect) return null;
  return new THREE.Vector2(
    ((screenX - canvasRect.left) / canvasRect.width) * 2 - 1,
    -((screenY - canvasRect.top) / canvasRect.height) * 2 + 1,
  );
}
